import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"error\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 30C23.2842 30 30 23.2843 30 15C30 6.7157 23.2842 0 15 0C6.71582 0 0 6.7157 0 15C0 23.2843 6.71582 30 15 30ZM13.4236 22.5V19.3767H16.5737V22.5H13.4236ZM13.5151 17.7945L13.332 7.5H16.6653L16.4822 17.7945H13.5151Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol